import { type CSSProperties, memo } from "react";
import { useSelector } from "react-redux";
import { type GroupedCartEntry } from "../../../../models/CartData";
import { ProductType } from "../../../../../../../models/ProductData";
import PlainProductEntry from "./PlainProductEntry";
import { KitProductEntry } from "~/feature/cart/cart/components/CartPage/ProductTable/ProductEntryList/KITProductEntry/KitProductEntry";
import {
  compareRGCEEquality,
  selectResolvedGroupedEntry,
} from "~/feature/cart/cart/components/CartPage/ProductTable/ProductEntryList/productEntryHelper";
import { useAlternateProducts } from "~/feature/cart/cart/AlternateProductsContext";

export interface ProductEntryProps {
  groupingEntry: GroupedCartEntry;
  className?: string;
  editMode?: boolean;
  index: number;
  style?: CSSProperties;
  onDelete: (productCode: string, designation: string) => void;
  onRender: (element: Element) => void;
}

const ProductEntry = (props: ProductEntryProps) => {
  const resolvedEntry = useSelector(selectResolvedGroupedEntry(props.groupingEntry), compareRGCEEquality);
  const { setScrollIndex } = useAlternateProducts();

  const product = resolvedEntry.descriptors[0];
  switch (product.base.type) {
    case ProductType.DEFAULT:
    case ProductType.CONFIGURATOR:
      return (
        <PlainProductEntry
          {...props}
          groupingEntry={resolvedEntry}
          onDelete={(productCode, designation) => {
            if (resolvedEntry.cartEntry.packEntryIds.length > 1) {
              setScrollIndex(-1);
              return;
            }
            props.onDelete(productCode, designation);
          }}
        />
      );

    case ProductType.KIT:
      return <KitProductEntry {...props} groupingEntry={resolvedEntry} />;

    default:
      throw new Error("Not implemented");
  }
};

export default memo(ProductEntry);
